import styled from "styled-components";
import { size } from "styled-theme";
import { PageWrapper } from "@containers/PageWrapper";

const Wrapper = styled(PageWrapper)`
  .center-full {
    margin-top: 40px;
    margin-bottom: 40px;
    min-height: calc(100vh - 295px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .capitalise .page-heading {
    text-transform: capitalize;
  }
  .margin-bottom {
    margin-bottom: 40px;
  }
  .margin-bottom-small {
    margin-bottom: 10px;
  }
  
  @media only screen and (max-width: ${size("S")}) {
    .secondary-header .page-heading {
      font-size: 18px;
    }
  }
`;

export default Wrapper;
